if (!customElements.get("td-cross-sell")) {
  class TdCrossSell extends HTMLElement {
    constructor() {
      super();
      
      this.atcButton = this.querySelector('.td-cross-sell__atc-wrapper');

      this.productId = this.atcButton.getAttribute('data-product-id');
      
      this.addToCart = this.addToCart.bind(this);
    }

    connectedCallback() {
      if (this.atcButton) {
        this.atcButton.addEventListener('click', this.addToCart);
      }
    }

    addToCart(event) {
      event.preventDefault();
      
      const data = {
        items: [{
          id: this.productId,
          quantity: 1
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(data => {
        this.updateCartDisplay(true); 
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
      });
    }

    updateCartDisplay(openCart = false) {
      fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        }
      })
      .then(response => response.json())
      .then(data => {
        if (GND) {
          GND.sidecart.refresh();
        }
        if (openCart && RC) {
          RC.sidePanel.open("#cart_panel");
        }
      })
      .catch(error => {
        console.error('Error updating cart display:', error);
      });
    }
  }

  customElements.define("td-cross-sell", TdCrossSell);
}
